import React from 'react';
import {MessageModelsList} from './components';

const MessageModel = () => {
  return <MessageModelsList />;
};

export default MessageModel;

